import React from 'react';

// @components
import SectionContainer from 'components/Containers/SectionContainer';
import Label from 'components/form/Label/Label';
import { AlertDetailsList } from 'pages/Alerts/components/AlertsDetails/components/AlertDetailsList';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import ActionsYouCanTake from '../../components/ActionsYouCanTake/ActionsYouCanTake';
import { Row } from 'components/Containers/Row/Row';
import FrequentlyAskedQuestions from 'components/FrequentlyAskedQuestions/FrequentlyAskedQuestions';

// @helpers
import { searchGoalModule } from 'helpers/goals.helpers';
import { ConditionalRendering } from 'helpers/conditionalRedering.helper';
import { getNumberOfDaysUntilNextFirstOfMonth } from 'helpers/dateHelper';

// @constants
import { CREDIT_CARD_VERTICAL } from 'types/mrph.vertical.constants';

// @images
import { Image } from 'components/Image/Image';

const actionsYouCanTake = [
  {
    title: 'Get rewarded',
    subtitle:
      'With a reward card, you can earn rewards on interest-free purchases if you pay off your balance in full every month.',
    takeAction: {
      module: 'REWARDS',
      title: 'Explore rewards cards',
      icon: 'exploreRewardsCardsIcon',
      link: '/goals/detail/REWARDS',
      vertical: CREDIT_CARD_VERTICAL,
      clickTile: 'Explore rewards cards',
    },
  },
  {
    title: 'Improve your credit usage grade',
    subtitle:
      'Use less of your available credit to raise your credit score by [increaseCreditScore] points in 6 months. Pay down credit accounts to decrease your credit usage and increase your credit usage grade, which makes up 30% of your score.',
    takeAction: {
      module: 'NEW_CC_SCORE_OVER_TIME',
      title: 'Potential score boost',
      icon: 'exploreCreditCardsIcon',
      link: '/goals/detail/NEW_CC_SCORE_OVER_TIME',
      vertical: CREDIT_CARD_VERTICAL,
      clickTile: 'Potential score boost',
    },
  },
];

const AccountPaidNotificationView = props => {
  const { alertDetailsConfig } = props;
  const creditScore = props?.creditInfo?.creditScore;
  const moduleToSearchScoreIncrease = 'NEW_CC_SCORE_OVER_TIME';

  const actionsToTakeFiltered = [];

  actionsYouCanTake.forEach(actionToTake => {
    const moduleSearch = searchGoalModule(
      props?.goals,
      actionToTake?.takeAction?.module,
    );
    if (moduleSearch?.offers) {
      const copyActionToTake = { ...actionToTake };
      if (actionToTake?.takeAction?.module === moduleToSearchScoreIncrease) {
        const newCardScoreSim =
          moduleSearch?.simulationsResponse?.successful?.[0];
        const simulation6Month =
          newCardScoreSim?.scoreOverTimeData['6'][0]?.score;
        const scoreIncrease = simulation6Month - creditScore;
        copyActionToTake.subtitle = copyActionToTake.subtitle.replace(
          '[increaseCreditScore]',
          scoreIncrease.toString(),
        );
      }
      actionsToTakeFiltered.push(copyActionToTake);
    }
  });

  const frequentlyAskedQuestion =
    props?.config?.notificationAlerts?.accountPaid?.frequentlyAskedQuestion;
  return (
    <SectionContainer className="cmAlertsDetailsContainer notificationsAlertsDetails">
      <Row className="text-28 fontLatoNormal700 margB16">
        <Label type="H4" typeHeader={'h4'}>
          {alertDetailsConfig.title}
        </Label>
      </Row>

      <Row>
        <FlexContainer column>
          <Label className="caption fontGray300">
            {`Reported on ${props.alertDetailsConfig?.date} to `}
            {props?.bureauLogo[props.selectedAlertDetails?.bureau]}
          </Label>
          <div className="alertDetailsImage margt20">
            <Image className={'accountPaidImage'} />
          </div>
          <Label bold className="text-16">
            The balance on this account is $0
          </Label>
          <Label type="Body1" className="margT16 mBody-2">
            You completely paid off this account's balance. Keep in mind that an
            account's status (like its balance) can take time to update on your
            credit reports after you take an action. Check for changes
            regularly.
          </Label>
          <AlertDetailsList
            alertDetailsList={alertDetailsConfig?.alertDetailsList}
            lineType={alertDetailsConfig?.lineType}
            datatestid={`${props.datatestid}-detailList`}
            outerClass={'padB0 margT16'}
          />
        </FlexContainer>
        <Label className="text-16 m-text-14 padt16">
          You'll see this change reflected in your account when your credit
          profile is updated in {getNumberOfDaysUntilNextFirstOfMonth()}.
        </Label>
      </Row>
      <div className="padTB4 bgGrey005"></div>
      <Row></Row>
      <ConditionalRendering isTrue={actionsToTakeFiltered.length > 0}>
        <Row>
          <ActionsYouCanTake
            title="Actions you can take"
            subTitle="Pay off as many accounts as you can for a positive impact on your payment history grade and your credit usage grade."
            actionsYouCanTake={actionsToTakeFiltered}
          />
        </Row>
        <div className="padTB4 bgGrey005"></div>
      </ConditionalRendering>
      <Row className="padt20">
        <FrequentlyAskedQuestions
          frequentlyAskedQuestion={frequentlyAskedQuestion}
        />
      </Row>
    </SectionContainer>
  );
};

export default AccountPaidNotificationView;
